import React, { useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import { toast } from 'react-toastify';
import { createBatchFromProductId } from '../../../../../services/products';
import Button from '../../../../../component/ui/Button';
import InputField from '../../../../../component/form/FormInput';
import { getDate } from '../../../../../utils/dateUtils';

export default function AddProductBatchModel({
	isOpenProductBatchModel,
	setIsOpenProductBatchModel,
	getProductBatchList,
	tableIndex,
	handleBatchChange,
	invoiceTable,
	setInvoiceTable,
}) {
	const [productBatch, setProductBatch] = useState({
		quantity: '',
		free_quantity: '',
		mfg_date: '',
		expiry_date: '',
		mrp: '',
		trade_rate: '',
		purchase_rate: '',
		sale_rate: '',
		batch_no: '',
	});
	const [error, setError] = useState({});
	const [isLoader, setLoader] = useState(false);
	const date = new Date();
	const ThisYear = date.getFullYear().toString().slice(-2);
	const Thismonth = (date.getMonth() + 1).toString().padStart(2, '0');

	function checkValidation() {
		let newError = { ...error };

		if (!productBatch.batch_no) {
			newError.batch_no = 'Please enter batch number in the field';
		} else {
			delete newError.batch_no;
		}

		if (
			Number(productBatch.free_quantity || 0) > 0 &&
			Number(productBatch?.quantity) < Number(productBatch.free_quantity)
		) {
			newError.free_quantity = 'Please enter free quantity in the field';
		} else {
			delete newError.free_quantity;
		}

		if (!productBatch.purchase_rate || Number(productBatch.purchase_rate) === 0) {
			newError.purchase_rate = 'Please enter purchase rate in the field';
		} else {
			delete newError.purchase_rate;
		}

		delete newError.mfg_date;
		delete newError.expiry_date;

		if (!productBatch.mrp || Number(productBatch.mrp) === 0) {
			newError.mrp = 'Please enter mrp in the field';
		} else {
			delete newError.mrp;
		}

		if (
			Number(productBatch.sale_rate) > 0 &&
			(Number(productBatch.sale_rate) < Number(productBatch.purchase_rate) ||
				Number(productBatch.sale_rate) > Number(productBatch.mrp))
		) {
			newError.sale_rate = 'Please enter sales rate in the field';
		} else {
			delete newError.sale_rate;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleDateChange = (field, value) => {
		let newError = { ...error };
		value = value.replace(/\D/g, '');

		if (value.length > 4) {
			value = value.slice(0, 4);
		}

		if (value.length >= 2) {
			let month = value.slice(0, 2);
			const year = value.slice(2);

			if (month > '12') {
				month = '12';
			}
			if (value.length === 2) {
				value = `${month}`;
			} else {
				value = `${month}/${year}`;
			}
		}
		if (field === 'expiry_date') {
			let currentRowmfg_date = productBatch?.mfg_date;
			if (
				value === '' ||
				currentRowmfg_date?.split('/')?.[1] > value?.split('/')?.[1] ||
				value === ''
			) {
				newError.expiry_date = 'Please enter valid expiry date';
			} else {
				delete newError.expiry_date;
			}
		}
		if (field === 'mfg_date') {
			if (
				value === '' ||
				value?.split('/')?.[1] > ThisYear ||
				(value?.split('/')?.[1] >= ThisYear && value?.split('/')?.[0] > Thismonth)
			) {
				newError.mfg_date = 'Please enter valid mfg date';
			} else {
				delete newError.mfg_date;
			}
		}

		setError(newError);

		setProductBatch((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handleInputChange = (field, value) => {
		let newError = { ...error };
		let currentRowValue = productBatch;

		if (field === 'batch_no') {
			if (value) {
				delete newError.batch_no;
			} else {
				newError.batch_no = 'Please enter batch number in the field.';
			}
		}

		if (field !== 'batch_no') {
			if (field === 'quantity' || field === 'free_quantity') {
				value = value?.replace(/[^0-9]/g, '');
			} else {
				value = value?.replace(/[^0-9.]/g, '');
				const decimalCount = (value.match(/\./g) || []).length;
				if (decimalCount > 1) {
					value = +value?.slice(0, value.lastIndexOf('.'));
				}
			}
		}

		if (field === 'free_quantity') {
			if (Number(value) > 0 && Number(currentRowValue?.quantity) < Number(value)) {
				newError.free_quantity = 'Please enter correct free quantity in the field';
			} else {
				delete newError.free_quantity;
			}
		}

		if (field === 'mrp') {
			const mrp = Number(value);
			const purchaseRate = Number(currentRowValue?.purchase_rate);

			if (mrp === 0) {
				newError.mrp = 'Please enter mrp in the field';
			} else {
				delete newError.mrp;
			}
			if (purchaseRate > 0 && purchaseRate > mrp) {
				newError.purchase_rate = 'Please enter purchase rate less than mrp in the field';
			} else {
				delete newError.mrp;
				delete newError.purchase_rate;
			}
		}

		if (field === 'quantity') {
			if (Number(currentRowValue.free_quantity) < Number(value)) {
				delete newError.free_quantity;
			} else {
				newError.free_quantity = 'Please enter correct free quantity in the field';
			}
		}

		if (field === 'purchase_rate') {
			const purchaseRate = Number(value);
			const mrp = Number(currentRowValue?.mrp);

			if (purchaseRate === 0 || purchaseRate === '' || (mrp > 0 && purchaseRate > mrp)) {
				newError.purchase_rate = 'Please enter purchase rate less than mrp in the field';
			} else {
				delete newError.mrp;
				delete newError.purchase_rate;
			}
		}

		if (field === 'sale_rate') {
			const purchaseRate = Number(currentRowValue?.purchase_rate);
			const mrp = Number(currentRowValue?.mrp);
			const saleRate = Number(value);

			if (saleRate > 0 && (saleRate < purchaseRate || saleRate > mrp)) {
				newError.sale_rate =
					'Please enter sales rate less than mrp and more than pur. rate in the field';
			} else {
				delete newError.sale_rate;
			}
		}
		setError(newError);
		setProductBatch((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const saveProductBatchById = async () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create new batch in the product.');
		} else {
			setLoader(true);
			let BatchData = [];
			BatchData?.push({
				quantity: productBatch?.quantity?.toString(),
				free_quantity: productBatch?.free_quantity?.toString(),
				mfg_date: productBatch?.mfg_date,
				expiry_date: productBatch?.expiry_date,
				mrp: productBatch?.mrp?.toString(),
				trade_rate: Number(productBatch?.trade_rate || 0)?.toString(),
				purchase_rate: productBatch?.purchase_rate?.toString(),
				sale_rate: Number(productBatch?.sale_rate || 0)?.toString(),
				batch_no: productBatch?.batch_no,
			});

			try {
				var body = {
					product_id: invoiceTable[tableIndex].product_id,
					product_batches: BatchData,
				};
				const res = await createBatchFromProductId(body);
				if (res.success) {
					const { batches } = res.data;
					// Fetch batch list & mark newly created batch in options first
					await getProductBatchList(
						invoiceTable[tableIndex].product_id,
						batches[0]?.product_batch_id,
						batches[0]?.batch_no,
					);

					let table = [...invoiceTable];
					table[tableIndex].batch_no = batches[0].batch_no;
					table[tableIndex].expiry_date =
						getDate(batches[0]?.expiry_date, false, false, true) ?? '';
					table[tableIndex].mrp = batches[0]?.mrp ?? '0.00';
					table[tableIndex].product_batch_id = batches[0]?.product_batch_id;
					setInvoiceTable(table);
					handleBatchChange(tableIndex, batches[0].batch_no, 'batch_no');
					setIsOpenProductBatchModel(false);
				} else {
					toast.error(res.message || 'Something went wrong!');
				}
			} catch (error) {
				toast.error(error.response.data.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	return (
		<Modal
			className="product_model"
			title={'Add New Batch'}
			isOpen={isOpenProductBatchModel}
			onClose={() => {
				setIsOpenProductBatchModel(false);
			}}
			cancelButton={() => {
				setIsOpenProductBatchModel(false);
			}}
		>
			<div className="row">
				<div className="col-3 my-2">
					<InputField
						label="Batch Number"
						placeholder="Batch Number"
						type="text"
						required={true}
						value={productBatch.batch_no}
						onChange={(valueData) => {
							handleInputChange('batch_no', valueData);
						}}
						error={error?.batch_no}
						autoFocus={true}
					/>
				</div>
				<div className="col-3 my-2">
					<InputField
						label="Quantity"
						placeholder="Quantity"
						type="text"
						required={true}
						value={productBatch.quantity}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleInputChange('quantity', value);
						}}
						error={error?.quantity}
						autoFocus={false}
					/>
				</div>
				<div className="col-2 my-2">
					<InputField
						label="Free Quantity"
						placeholder="Free Quantity"
						type="text"
						required={false}
						value={productBatch.free_quantity}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleInputChange('free_quantity', value);
						}}
						error={error?.free_quantity}
						autoFocus={false}
					/>
				</div>
				<div className="col-2 my-2">
					<InputField
						label="MFG Date"
						placeholder="MM/YY"
						type="text"
						required={false}
						value={productBatch.mfg_date}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9'/]/g, '');
							handleDateChange('mfg_date', value);
						}}
						error={error?.mfg_date}
						autoFocus={false}
					/>
				</div>
				<div className="col-2 my-2">
					<InputField
						label="EXP Date"
						placeholder="MM/YY"
						type="text"
						required={false}
						value={productBatch.expiry_date}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9'/]/g, '');
							handleDateChange('expiry_date', value);
						}}
						error={error?.expiry_date}
						autoFocus={false}
					/>
				</div>
				<div className="col-3 my-2">
					<InputField
						label="MRP"
						placeholder="0.00"
						type="text"
						required={true}
						value={productBatch.mrp}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9.]/g, '');
							handleInputChange('mrp', value);
						}}
						error={error?.mrp}
						autoFocus={false}
					/>
				</div>
				<div className="col-3 my-2">
					<InputField
						label="Trade Rate"
						placeholder="0.00"
						type="text"
						required={false}
						value={productBatch.trade_rate}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9.]/g, '');
							handleInputChange('trade_rate', value);
						}}
						error={error?.trade_rate}
						autoFocus={false}
					/>
				</div>
				<div className="col-3 my-2">
					<InputField
						label="Purchase Rate"
						placeholder="0.00"
						type="text"
						required={true}
						value={productBatch.purchase_rate}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9.]/g, '');
							handleInputChange('purchase_rate', value);
						}}
						error={error?.purchase_rate}
						autoFocus={false}
					/>
				</div>
				<div className="col-3 my-2">
					<InputField
						label="Sales Rate"
						placeholder="0.00"
						type="text"
						required={false}
						value={productBatch.sale_rate}
						onChange={(valueData) => {
							const value = valueData.replace(/[^0-9.]/g, '');
							handleInputChange('sale_rate', value);
						}}
						error={error?.sale_rate}
						autoFocus={false}
					/>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
					marginTop: '10px',
					gap: '10px',
				}}
			>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => setIsOpenProductBatchModel(false)}
				/>
				<Button
					type="button"
					button={`Save`}
					disabled={isLoader}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => saveProductBatchById()}
					loader={isLoader}
				/>
			</div>
		</Modal>
	);
}
